import React from "react";
import { getDefaultFinancingPlan } from "tsi-common-react/src/utils/financing";
import { formatFinancingPlan } from "tsi-common-react/src/utils/format";
import { c, t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const FinancingModalTriggerRetailModalFinance = () => {
    const plan = formatFinancingPlan(getDefaultFinancingPlan());

    const rootClassNames = concatClassNames([styles.root, styles.fallback]);
    const detailsLinkClassNames = concatClassNames([
        styles.link,
        styles.seeSmall,
        "al-more-ways-to-buy-financing_ad",
    ]);
    return (
        <span>
            <div className={rootClassNames}>
                <div className={styles.see}>
                    <div className={styles.seeBold}>
                        {c("FinancingModalTriggerRetailModalFinance")
                            .t`${plan.apr} APR for ${plan.length} Months`}
                        <sup>
                            {/* TODO(i18n): Hardcoded URL may need localization or relative path handling */}
                            <a href="/finance-your-purchase#terms_and_conditions">
                                {plan.superscript}
                            </a>
                        </sup>
                    </div>
                    {/* TODO(i18n): Hardcoded URL may need localization or relative path handling */}
                    <a
                        href="/finance-your-purchase"
                        className={detailsLinkClassNames}
                    >
                        {t`See Financing Details`}
                    </a>
                </div>
            </div>
        </span>
    );
};
